// Hide rejected and restore record hints
export const EXCLUDED_CHANGE_TYPES = [
  'ADD_PERSON_ANTI_LINK_REFERENCE',
  'DELETE_PERSON_ANTI_LINK_REFERENCE',
  'SPLIT_PERSON_COMPLETED', // we only care about SPLIT_PERSON
]
